
import { FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Control } from "react-hook-form";
import { MARKET_OPTIONS } from "@/constants/buyerFormOptions";

interface PreferredMarketsFieldProps {
  control: Control<any>;
  selectedMarkets: string[];
  onMarketToggle: (market: string, checked: boolean) => void;
  isEditing: boolean;
}

const PreferredMarketsField = ({
  control,
  selectedMarkets,
  onMarketToggle,
  isEditing
}: PreferredMarketsFieldProps) => {
  return (
    <FormField
      control={control}
      name="preferredMarkets"
      render={() => (
        <FormItem>
          <FormLabel>Preferred Markets</FormLabel>
          <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 max-h-48 overflow-y-auto p-4 rounded border ${!isEditing ? 'bg-muted border-muted' : 'bg-background border-border'}`}>
            {MARKET_OPTIONS.map((market) => (
              <div key={market} className="flex items-center space-x-2">
                <Checkbox
                  id={market}
                  checked={selectedMarkets.includes(market)}
                  onCheckedChange={(checked) => onMarketToggle(market, checked as boolean)}
                  disabled={!isEditing}
                />
                <Label 
                  htmlFor={market} 
                  className={`text-sm cursor-pointer ${!isEditing ? 'text-muted-foreground' : ''}`}
                >
                  {market}
                </Label>
              </div>
            ))}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PreferredMarketsField;
